import { SolutionContextProvider } from '@datacamp/input-fields';
import * as React from 'react';
import { useSelector } from 'react-redux';
import selectLocalExercise from '../selectors/selectLocalExercise';
import { jsx as ___EmotionJSX } from "@emotion/react";
const defaultContext = {
  hasSolution: false,
  solutionShown: 0
};
export const ProvidedSolutionContext = _ref => {
  let {
    children,
    exercise,
    exerciseId
  } = _ref;
  const localExercise = useSelector(state => selectLocalExercise(state, exerciseId));
  let context = defaultContext;
  if (localExercise != null && exercise != null) {
    context = {
      hasSolution: exercise.question.flavor === 'Open',
      solutionShown: localExercise === undefined ? 0 : localExercise.solutionShown
    };
  }
  return ___EmotionJSX(SolutionContextProvider, {
    context: context
  }, children);
};